import { ApiResponse, ApisauceInstance } from 'apisauce'
import { Instance } from 'mobx-state-tree'
import { Resource } from '../../models/Resource'
import {
  GetResource,
  GetResourceTopic,
  GetResourceQuiz,
} from '../../models/response-models/resource'
import { handleResponse } from '../handleResponse'
import { AxiosRequestConfig, CancelTokenSource } from 'axios'

export const ResourceApi = {
  apisauce: {} as ApisauceInstance,
  getAllResources: async (
    type: any,
    meta?: boolean,
    columns?: any,
    view_name?: string,
    // view_id?: number,
    id?: number,
  ) => {
    const payload = { view_name }
    if (columns && columns.length > 0) {
      payload['columns'] = columns
    }

    const response: ApiResponse<any> = await ResourceApi.apisauce.post(
      id
        ? `/${type}/${id}/sources/?meta=${meta}&asynchronous=${false}`
        : `/${type}/?meta=${meta}&asynchronous=${false}`,
      payload,
    )

    return handleResponse(response)
  },
  getSourceDetails: async (id) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(`/sources/${id}/`, {})
    return handleResponse(response)
  },
  getResourceDetails: async (id) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(`/resources/${id}/`, {})
    return handleResponse(response)
  },
  getAllResourcesOrSingleById: async (id?: number) => {
    const res = await ResourceApi.getAllResources(
      'sources',
      false,
      [
        { field: 'source_title' },
        { field: 'source_created_date' },
        { field: 'source_filename_url' },
        { field: 'source_file_size' },
        { field: 'source_file_type' },
        { field: 'source_view_count' },
        { field: 'source_word_count' },
        { field: 'source_topic_count' },
        { field: 'source_quiz_count' },
        { field: 'source_created_by' },
        { field: 'source_last_edited_by' },
        { field: 'source_last_edited_date' },
        { field: 'source_unique_viewer_count' },
      ],
      'list_sources',
    )
    if (res.ok && res.data) {
      const rList = [] as any
      res.data?.rows.map((source) => {
        const title = source.columns.find((column) => column.field === 'source_title')
        const created_at = source.columns.find((column) => column.field === 'source_created_date')
        const filename_or_url = source.columns.find(
          (column) => column.field === 'source_filename_url',
        )
        const file_size = source.columns.find((column) => column.field === 'source_file_size')
        const download_url = source.columns.find((column) => column.field === 'download_url')
        const pdf_url = source.columns.find((column) => column.field === 'pdf_url')
        const mime_type = source.columns.find((column) => column.field === 'source_file_type')
        const view_count = source.columns.find((column) => column.field === 'source_view_count')
        const topic_count = source.columns.find((column) => column.field === 'source_topic_count')
        const quiz_count = source.columns.find((column) => column.field === 'source_quiz_count')
        const created_by = source.columns.find((column) => column.field === 'source_created_by')
        const word_count = source.columns.find((column) => column.field === 'source_word_count')
        const unique_views = source.columns.find(
          (column) => column.field === 'source_unique_viewer_count',
        )
        const last_edited_by = source.columns.find(
          (column) => column.field === 'source_last_edited_by',
        )
        const last_edited_date = source.columns.find(
          (column) => column.field === 'source_last_edited_date',
        )

        const formattedResource = {
          pdf_url: pdf_url.value,
          download_url: download_url.value,
          source_id: source.id,
          created_at: created_at.value,
          title: title.value,
          filename_or_url: filename_or_url.value,
          file_size: file_size.value,
          mime_type: mime_type.value,
          extension: mime_type.value,
          view_count: view_count.value,
          topic_count: topic_count.value,
          quiz_count: quiz_count.value,
          word_count: word_count.value,
          created_by: created_by.value,
          last_edited_by: last_edited_by.value,
          last_edited_date: last_edited_date.value,
          unique_views: unique_views.value,
        }

        rList.push(formattedResource)
      })

      if (id) {
        const result = rList.find((f) => f.source_id === id)
        return result
      }
      return rList
    } else {
      throw new Error('Error ocurred')
    }
  },
  getResourceStatus: async (id: number) => {
    const payload = {
      view_name: 'list_sources',
      columns: [{ field: 'source_processing_status' }],
      primary_key: id,
    }

    const response: ApiResponse<any> = await ResourceApi.apisauce.get(`/resources/${id}/`, {})

    const res = await handleResponse(response)
    if (res.ok && res.data) {
      return res.data?.processing_status
    } else {
      return handleResponse(response)
    }
  },
  getAvailableResources: async (primary_key?: number) => {
    const payload = {
      view_name: 'list_sources',
      columns: [
        { field: 'source_created_date' },
        { field: 'source_title' },
        { field: 'source_filename_url' },
        { field: 'source_file_size' },
        { field: 'source_file_type' },
        { field: 'source_mimetype' },
        { field: 'source_processing_status' },
      ],
      ...(primary_key && { primary_key }),
    }

    const response: ApiResponse<any> = await ResourceApi.apisauce.post(
      `/sources/?meta=false&asynchronous=${false}`,
      payload,
    )
    const res = await handleResponse(response)

    if (res.ok && res.data) {
      const rList = [] as any
      res.data?.rows.map((source) => {
        const title = source.columns.find((column) => column.field === 'source_title')
        const created_at = source.columns.find((column) => column.field === 'source_created_date')
        const filename_or_url = source.columns.find(
          (column) => column.field === 'source_filename_url',
        )
        const file_size = source.columns.find((column) => column.field === 'source_file_size')
        const file_type = source.columns.find((column) => column.field === 'source_file_type')
        const mime_type = source.columns.find((column) => column.field === 'source_mimetype')
        const processing_status = source.columns.find(
          (column) => column.field === 'source_processing_status',
        )

        const formattedResource = {
          source_id: source.id,
          created_at: created_at.value,
          title: title.value,
          filename_or_url: filename_or_url.value,
          file_size: file_size.value,
          mime_type: mime_type.value,
          extension: mime_type.value,
          processing_status: processing_status.value,
        }
        rList.push(formattedResource)
      })
      return { ok: true, data: rList }
    } else {
      return handleResponse(response)
    }
  },
  generateQuestions: async (
    resource_id: number,
    count: number,
    keywords,
    audience: string,
    voice: string,
    difficulty: number,
    question_types: string[],
    node_ids: number[],
    summarize?: boolean,
    exclude_choices?: string[],
  ) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.post(
      `/generate/questions/from_resource/`,
      {
        resource_id,
        count,
        keywords,
        question_types,
        audience: audience === '' ? null : audience,
        voice: voice === '' ? null : voice,
        difficulty,
        node_ids,
        summarize,
        exclude_choices,
      },
    )
    return handleResponse(response)
  },
  addResource: async (
    onUploadProgress: (progressEvent: ProgressEvent) => void,
    resourcePayload: {
      title: string
      url?: string
      file?: File
      file_size?: number
      mime_type?: string
    },
    source?: CancelTokenSource,
  ) => {
    const formData: any = new FormData()

    formData.append('title', resourcePayload.title.slice(0, 127))

    if (resourcePayload.url) {
      formData.append('url', resourcePayload.url)
    } else {
      formData.append('source_file', resourcePayload.file)
      formData.append('file_size', resourcePayload.file_size)
      formData.append('mime_type', resourcePayload.mime_type)
    }

    const options: AxiosRequestConfig = {
      onUploadProgress,
    }

    if (source) {
      options.cancelToken = source.token
    }

    if (resourcePayload.url) {
      const response: ApiResponse<{
        source_id: number
        resource_id: number
      }> = await ResourceApi.apisauce.post(
        `/sources/create/url/`,
        {
          title: resourcePayload.title.slice(0, 127),
          url: resourcePayload.url,
        },
        options,
      )
      return handleResponse(response)
    } else {
      const response: ApiResponse<{
        source_id: number
        resource_id
      }> = await ResourceApi.apisauce.post(`/sources/create/file/`, formData, options)
      return handleResponse(response)
    }
  },

  uploadTextResource: async (text, title) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.post(`/sources/create/text/`, {
      text,
      title,
    })
    return handleResponse(response)
  },

  updateResource: async (resource: Instance<typeof Resource>) => {
    const response: ApiResponse<null> = await ResourceApi.apisauce.patch(
      `/sources/${resource.source_id}/`,
      {
        title: resource.title,
        is_locked: false,
        is_archived: false,
        is_deleted: false,
        alt_text: null,
      },
    )

    return handleResponse(response)
  },
  getTopicsOfResource: async (source_id: number) => {
    const response: ApiResponse<Array<Instance<typeof GetResourceTopic>>> =
      await ResourceApi.apisauce.get(`/sources/${source_id}/topics/`)
    return handleResponse(response)
  },
  getQuizzesOfResource: async (source_id: number) => {
    const response: ApiResponse<Array<Instance<typeof GetResourceQuiz>>> =
      await ResourceApi.apisauce.get(`/sources/${source_id}/quizzes/`)
    return handleResponse(response)
  },
  addResourceToTopics: async (source_id: number, topic_ids: Array<number>) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.post(
      `/sources/${source_id}/add_topics/`,
      {
        topic_ids,
      },
    )
    return handleResponse(response)
  },
  addResourceToQuizzes: async (source_id: number, quiz_ids: Array<number>, required: boolean) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.post(
      `/sources/${source_id}/add_quizzes/`,
      {
        quiz_ids,
        required,
      },
    )
    return handleResponse(response)
  },
  getResourceDocument: async (source_id) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(
      `/resources/${source_id}/document/`,
    )
    return handleResponse(response)
  },
  getSummary: async (resource_id) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(
      `/resources/${resource_id}/summary/`,
    )
    return handleResponse(response)
  },
  updateSummary: async (resource_id: number, summary: string) => {
    const response: ApiResponse<null> = await ResourceApi.apisauce.patch(
      `resources/${resource_id}/summary/`,
      { summary },
    )

    return handleResponse(response)
  },
  getKeywords: async (resource_id) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(
      `/resources/${resource_id}/keywords/`,
    )
    return handleResponse(response)
  },
  checkSubject: async (subject: string) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(
      `/generate/check_subject/?subject=${subject}`,
    )
    return handleResponse(response)
  },
  findSources: async (subject: string) => {
    const response: ApiResponse<any> = await ResourceApi.apisauce.get(
      `/generate/sources/?subject=${subject}`,
    )
    return handleResponse(response)
  },

  processResource: async (resource_id: number) => {
    const response: ApiResponse<null> = await ResourceApi.apisauce.post(
      `/resources/${resource_id}/document/`,
    )

    // can't be processed or starts processing
    return handleResponse(response)
  },
}
